import axios from 'axios';

const state = {
	firm: [],
	success: false,
	loading: false,
	message: "",
}

const mutations = {
	UPDATE_FIRMLIST(state, payload) {
		state.firm = payload;
		setSuccessState(state);
	},
	UPDATE_CHECKFIRM(state, payload) {
		if (payload.success) {
			setSuccessState(state);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVEFIRM(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_LOADING(state) {
		setLoadingState(state);
	},
	UPDATE_ERROR(state, payload) {
		setErrorState(state, payload);
	},
}

const actions = {
	getFirmList({ commit }) {
		commit('UPDATE_LOADING');
		axios.get('firm').then((response) => {
			commit('UPDATE_FIRMLIST', response.data)
		});
	},
	checkFirm({ commit, state }, data) {
		commit('UPDATE_LOADING');
		axios.get(`firm/existsFirm?name=${data.name}&uid=${data.uid}`).then((response) => {
			commit('UPDATE_CHECKFIRM', response.data)
		});
	},
	save({ commit }, firmData) {
		commit('UPDATE_LOADING');
		axios.post('firm', firmData)
		.then((response) => {
			commit('UPDATE_SAVEFIRM', response.data)
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	updateFirm({ commit }, firmData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios.put('/firm', firmData)
			.then((response) => {
				commit('UPDATE_SAVEFIRM', response.data)
				resolve(response.data);
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject(error);
			});
		});
	}
};

const getters = {
	firm: state => state.firm,
	success: state => state.success,
	loading: state => state.loading,
	message: state => state.message,
}

function setLoadingState(state) {
	state.success = false;
	state.loading = true;
	state.message = "";
}

function setSuccessState(state, message = "") {
	state.success = true;
	state.loading = false;
	state.message = message;
}

function setErrorState(state, message = "") {
	state.success = false;
	state.loading = false;
	state.message = message;
}

const firmModule = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

export default firmModule;
